import React from 'react'
import { Accordion, Card, Button } from 'react-bootstrap'
import CustomSpinner from '../../generic/CustomSpinner'
import ComponentTable from '../../generic/ComponentsTable'
import { useState, useContext, useEffect } from 'react'
import { ModalContext } from '../../../context/modalContext'
import { ConfirmModalContext } from '../../../context/confirmModalContext'
import AddEtapaVidaReligiosa from '../formularios/AddEtapaVidaReligiosa'
import $ from "jquery";
import { AlertBoxContext } from '../../../context/alertBoxContext'


// Images
import Icon from '../../generic/Icon'
import deleteIcon from "../../../assets/delete.png";
import editIcon from "../../../assets/editing.png";

const EtapasVidaReligiosa = ({esMonja, userId, hermanaId, datosUsuario, accessLevel, ...props }) => {
    //console.log(hermanaId)
    // Alertas
    const { addAlert } = useContext(AlertBoxContext);

    const [loading, setLoading] = useState(false);
    const [etapasVidaReligiosa, setEtapaVidaReligiosa] = useState({})
    
    const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

    // Ventana de confirmación
    const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

    useEffect(() => {
        handleObtenerEtapasVidaReligiosa()
    }, [])

    const obtenerEtapasVidaReligiosa = () => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/hermanas/${hermanaId}/votos`,
            method: "GET",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    }

    const handleObtenerEtapasVidaReligiosa = () => {
        setLoading(true);
        obtenerEtapasVidaReligiosa()
            .then((response) => {
                //console.log(response)
                setEtapaVidaReligiosa(response);
                setLoading(false);
            })
            .catch((e) => {
                //console.log(e)
                setLoading(false);
            });
    }
    
    const handlePostEtapaVidaReligiosa = (data) => {
        //añade etapa vida religiosa
        //console.log({'daaaaaaata':data})
        setLoading(true);
        let settings = {
        url: process.env.REACT_APP_API_URL + `/hermanas/${hermanaId}/votos`,
        method: "POST",
        xhrFields: {
            withCredentials: true,
        },
        data: data,
        };
        return $.ajax(settings)
    }

    const handlePutEtapaVidaReligiosa = (data) => {
        //añade etapa vida religiosa
        //console.log({'daaaaaaata':data})
        //console.log(process.env.REACT_APP_API_URL + `/hermanas/${hermanaId}/votos/${data.id}`)
            setLoading(true);
            let settings = {
              url: process.env.REACT_APP_API_URL + `/hermanas/${hermanaId}/votos/${data.id}`,
              method: "PUT",
              xhrFields: {
                withCredentials: true,
              },
              data: data,
            };
            return $.ajax(settings)
              
        

    }

    const handleForm = (datum, post) => {
        modalSetShow(false);
        //console.log(datum)
       // console.log(post)
        setLoading(true);
        if (post) {
            //console.log('PPPPPPPPPPPPPPPPPPPPPPPOST')
            handlePostEtapaVidaReligiosa(datum)
                .then(() => {
                    setLoading(false);
                    handleObtenerEtapasVidaReligiosa()
                    addAlert("Éxito", "Se ha añadido la etapa religiosa correctamente", "success");
                })
                .catch(() => {
                    setLoading(false);
                    addAlert("Error", "Error al agregar la etapa religiosa", "danger");
                });
        } else {
            //console.log('PUUUUUUUUUUUUUUUUUUUUUUUT')
            handlePutEtapaVidaReligiosa(datum)
                .then(() => {
                    setLoading(false);
                    handleObtenerEtapasVidaReligiosa()
                    addAlert("Éxito", "Se ha actualizado la etapa religiosa correctamente", "success");
                })
                .catch(() => {
                    setLoading(false);
                    addAlert("Error", "Error al actualizar la etapa religiosa", "danger");
                });
        }


    }

    const handleDeleteEtapaVidaReligiosa = (data) => {
        setLoading(true);
        //console.log(data)
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/hermanas/${data.sisterId}/votos/${data.id}`,
            method: "DELETE",
            xhrFields: {
                withCredentials: true,
            },
        };
         $.ajax(settings)
               .then(() => {
                addAlert("Exito", `Se ha eliminado la etapa religiosa`, "success");
                handleObtenerEtapasVidaReligiosa()
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                addAlert("Error", `No se ha podido eliminar la etapa religiosa`, "danger");
            });
    }

    //TABLA

    const columnasTabla = () => {
        return accessLevel > 8 ? [
            { name: "Voto", value: procesaVoto },
            { name: "Fecha", value: procesaFecha },
            { name: "Provincia", value: procesaProvincia },
            { name: "Comunidad", value: procesaComunidad },
            { name: "Editar", value: editTupla },
            { name: "Eliminar", value: deleteTupla },
        ]
            :
            [
                { name: "Voto", value: procesaVoto },
                { name: "Fecha", value: procesaFecha },
                { name: "Provincia", value: procesaProvincia },
                { name: "Comunidad", value: procesaComunidad },
            ]
    }

    const procesaVoto = (row) => {
        //console.log(row)
        return row?.vow_type.type;
    }
    const procesaFecha = (row) => {
        return row?.date;
    }
    const procesaProvincia = (row) => {
        return row?.community?.province?.name;
    }
    const procesaComunidad = (row) => {
        return row?.community?.name;
    }

    // Gestiona la acción que se realiza cuando damos en la imagen de editar cargo
    const editTupla = (row) => {
        //console.log(row)
        return (
            <Icon
                src={editIcon}
                onClick={() => {
                    modalSetShow(true, "80%");
                    modalSetTitle(`Editar destino de la hermana`);
                    modalSetContent(<AddEtapaVidaReligiosa 
                        handleForm={handleForm} 
                        hermanaId={hermanaId} 
                        edicion={row} />);
                }}
                className="d-flex m-auto"
            />
        );

    };

    // Gestiona la acción que se realiza cuando damos en la imagen de eliminar cargo
    const deleteTupla = (row) => {
        return (
            <Icon
                src={deleteIcon}
                onClick={() => {

                    confirmModalSetTitle(`Eliminar destino de la hermana`)
                    confirmModalSetContent(<p> {`¿Está seguro de que quiere eliminar el destino de la hermana?`} </p>)
                    confirmModalSetFunction(() => {
                        handleDeleteEtapaVidaReligiosa(row)
                    })
                    confirmModalSetShow(true)

                }}
                className="d-flex m-auto"
            />
        );
    };

    //FIN TABLA

  return (
    <>
            <div style={{ position: "relative" }}>
                <CustomSpinner animation={"border"} loading={loading} />
                <Accordion defaultActiveKey="1">
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle eventKey="0" as={Button} variant="link">
                               Etapas de Vida Religiosa
                            </Accordion.Toggle>
                            {accessLevel >= 9 && (
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="float-right mr-4"
                                    onClick={() => {
                                        modalSetShow(true, "60%");
                                        modalSetTitle("Añadir etapa religiosa de la hermana");
                                        modalSetContent(<AddEtapaVidaReligiosa
                                            handleForm={handleForm} 
                                            hermanaId={hermanaId}
                                            />);
                                    }}
                                >
                                    Añadir
                                </Button>
                                )}
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <p>
                                    <small>(Ordenada de más antigua a más reciente)</small>
                                    <br></br>
                                    {//accessLevel >8 && <small>(RECUERDE que no puede eliminar un destino vencido, ni uno en vigor, ni el último destino de la hermana)</small>
                                    }
                                </p>
                                
                                {etapasVidaReligiosa.length ? <ComponentTable
                                    emptyTableComponent={<p className="m-2">{`No hay destinos para esta hermana`}</p>}
                                    headers={columnasTabla()}
                                    rows={etapasVidaReligiosa}
                                />
                                    : (
                                        <p>No hay etapas realizadas para esta hermana</p>
                                    )}
                                {/*   {cursos.length ? (
                cursos.map((situacion) => {
                  return <SituacionParticular accessLevel={accessLevel} key={situacion.id} situacionParticular={situacion} deleteSituacionParticularState={deleteSituacionParticular} />;
                })
              ) : (
                <p>No hay situaciones particulares actualmente.</p>
              )}*/}

                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        </>
  )
}

export default EtapasVidaReligiosa